import React from 'react';
import { FiEdit } from 'react-icons/fi';
import TableColumnTitle from '../../../../components/_table/TableColumnTitle';
import Anchor from '../../../../components/link/Anchor';
import TableColumnImg from '../../../../components/table/TableColumnImg';
import Tag from '../../../../components/tag/Tag/Tag';
import OpenPreviewTagDetail from '../../../../containers/app/common/OpenPreviewTagDetail';
import { TAG_EDIT_URL_PATH, TAG_HISTORY_URL_PATH } from '../../../../constants/service/common/urlConstants';
import { TAG_STATUS_TEXT } from '../../../../constants/service/app/tagConstants';
import { reDirectPage, setDash, setDetailPageUrl, setNumberWithComma } from '../../../../lib/common';
import { setDateFormat } from '../../../../lib/moment';

/**
 *  태그 리스트 컬림
 */
export const columns = (data) => {
  const { sortOption, getRelatedTagList } = data;

  return [
    {
      title: <TableColumnTitle title={'수정'} />,
      dataIndex: 'edit',
      render: (value, record) => (
        <FiEdit
          onClick={() =>
            reDirectPage({
              path: setDetailPageUrl(TAG_EDIT_URL_PATH, record.id),
            })
          }
        />
      ),
    },
    {
      title: <TableColumnTitle title={'이미지'} />,
      dataIndex: 'url',
      sorter: true,
      sortOrder: sortOption['url'],
      render: (value) => <TableColumnImg url={value} width={'60px'} height={'60px'} />,
    },
    {
      title: <TableColumnTitle title={'태그 ID'} />,
      dataIndex: 'id',
      render: (value) => (
        <Anchor
          text={value}
          isUnderLine
          color="primary"
          href={setDetailPageUrl(TAG_HISTORY_URL_PATH, value)}
          target="_blank"
        />
      ),
    },
    {
      title: <TableColumnTitle title={'태그명'} />,
      dataIndex: 'name',
      render: (value, record) => <OpenPreviewTagDetail text={value} tagId={record.id} />,
    },
    {
      title: <TableColumnTitle title={'태그 상태'} />,
      dataIndex: 'status',
      render: (value) => TAG_STATUS_TEXT[value],
    },
    {
      title: <TableColumnTitle title={'태그 그룹'} />,
      dataIndex: 'tagGroupList',
      render: (value) =>
        value && value.length
          ? value.map((tagGroupName, index) => <Tag key={index} text={tagGroupName} isAddHash={false} />)
          : setDash(value),
    },
    {
      title: <TableColumnTitle title="연관된 태그" />,
      dataIndex: 'isRelatedTagExists',
      render: (value, record) => (
        <Anchor
          text="태그 보기"
          isUnderLine
          color="primary"
          onClick={() =>
            getRelatedTagList({
              tagId: record.id,
            })
          }
        />
      ),
    },
    {
      title: <TableColumnTitle title={'유저 태그 팔로워 수'} />,
      dataIndex: 'userFollowerCount',
      sorter: true,
      sortOrder: sortOption['userFollowerCount'],
      render: (value) => setNumberWithComma(value),
    },
    {
      title: <TableColumnTitle title={'클릭 수 (조회)'} />,
      dataIndex: 'clickCount',
      sorter: true,
      sortOrder: sortOption['clickCount'],
      render: (value) => setNumberWithComma(value),
    },
    {
      title: <TableColumnTitle title={'검색 수 (조회)'} />,
      dataIndex: 'searchCount',
      sorter: true,
      sortOrder: sortOption['searchCount'],
      render: (value) => setNumberWithComma(value),
    },
    {
      title: <TableColumnTitle title={'연결된 상품 수'} />,
      dataIndex: 'productLinkCount',
      sorter: true,
      sortOrder: sortOption['productLinkCount'],
      render: (value) => setNumberWithComma(value),
    },
    {
      title: <TableColumnTitle title={'연결된 상점 수'} />,
      dataIndex: 'storeLinkCount',
      sorter: true,
      sortOrder: sortOption['storeLinkCount'],
      render: (value) => setNumberWithComma(value),
    },
    {
      title: <TableColumnTitle title={'연결된 기획전 수'} />,
      dataIndex: 'eventLinkCount',
      sorter: true,
      sortOrder: sortOption['eventLinkCount'],
      render: (value) => setNumberWithComma(value),
    },
    {
      title: <TableColumnTitle title={'연결된 상품 후기 수'} />,
      dataIndex: 'reviewLinkCount',
      sorter: true,
      sortOrder: sortOption['reviewLinkCount'],
      render: (value) => setNumberWithComma(value),
    },
    {
      title: <TableColumnTitle title={'생성일'} />,
      dataIndex: 'createDate',
      sorter: true,
      sortOrder: sortOption['createDate'],
      render: (value) => setDateFormat(value),
    },
  ];
};
